import { ReactComponent as WebPay1 } from '@src/assets/web_pay_1.svg'
import { ReactComponent as WebPay2 } from '@src/assets/web_pay_2.svg'
import { ReactComponent as WebPay3 } from '@src/assets/web_pay_3.svg'
import { ReactComponent as WebPay4 } from '@src/assets/web_pay_4.svg'
import { ReactComponent as WebPay5 } from '@src/assets/web_pay_5.svg'
import { ReactComponent as WebPay6 } from '@src/assets/web_pay_6.svg'
import style from '../PaymentMethods.module.scss'

export const Ecash = () => (
  <div className={style.eCash}>
    <h2 className={style.bm} id="electronic">Оплата услуг электронными деньгами</h2>
    <p className={style.bm_text}>
      Вы можете воспользоваться такими платежными
      системами, как:
    </p>

    <div className={style.web_pay_items}>
      <div className={style.item}>
        <div className={style.img_bl}><WebPay1 /></div>
        <div>
          <a href="https://ssl.easypay.by/sou/service/cosmostv/">EASYPAY</a>
        </div>
      </div>

      <div className={style.item}>
        <div className={style.img_bl}><WebPay2 /></div>
        <div><a href="http://webmoney.by/">WEBMONEY</a></div>
      </div>

      <div className={style.item}>
        <div className={style.img_bl}><WebPay3 /></div>
        <div><a href="https://e-pay.by/">E-pay</a></div>
      </div>

      <div className={style.item}>
        <div className={style.img_bl}><WebPay4 /></div>
        <div>
          <a href="http://www.belarusbank.by/ru_16769.htm">
            Интернет–банкинг
            Беларусбанк
          </a>
        </div>
      </div>

      <div className={style.item}>
        <div className={style.img_bl}><WebPay5 /></div>
        <div>
          <a href="https://www.prior.by/web/">
            Интернет-банк Prior On-line от
            Приорбанка
          </a>
        </div>
      </div>

      <div className={style.item}>
        <div className="img_bl"><WebPay6 /></div>
        <div>
          <a href="https://click.alfa-bank.by/">Интернет-банк Альфа-банка</a>
        </div>
      </div>
    </div>
  </div>
)
